import { render, staticRenderFns } from "./ysv2.vue?vue&type=template&id=6c91bdfe&scoped=true"
import script from "./ysv2.vue?vue&type=script&lang=js"
export * from "./ysv2.vue?vue&type=script&lang=js"
import style0 from "./ysv2.vue?vue&type=style&index=0&id=6c91bdfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91bdfe",
  null
  
)

export default component.exports